export default "__VITE_ASSET__175adce8__"